import { claimShare } from "../lib/store";
import { t } from "../lib/i18n";
import { h, mount } from "../ui/dom";
import { navigate } from "../ui/router";
import { signedIn } from "../ui/app";

/**
 * Landing point for a share link.
 *
 * The token is the capability: there is no RLS policy for visibility='link', so
 * the collection isn't readable until `claim_shared_collection` trades the token
 * for an enrollment. Claiming therefore has to happen before we can navigate to
 * the collection at all.
 */
export async function renderShareClaim(token: string, host: HTMLElement): Promise<void> {
  mount(host, h("div", { class: "screen" }, h("p", { class: "muted", text: t("loading") })));

  if (!signedIn) {
    // Claiming writes an enrollment row, so it needs a session. Preserve the
    // token in the hash so signing in and coming back still works.
    mount(
      host,
      h("div", { class: "screen stack" },
        h("h2", { text: t("signIn") }),
        h("p", { class: "muted", text: t("signInPitch") }),
        h("button", { class: "primary", text: t("signIn"), on: { click: () => navigate("/signin") } }),
      ),
    );
    return;
  }

  const id = await claimShare(token);
  navigate(`/c/${id}`, true);
}
